import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import ButtonLoading from "../components/ButtonLoading";
import { QRCodeCanvas } from "qrcode.react";
import { Event } from "../interfaces/Event";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { getUserByEmail } from "../api/user";
import Input from "../components/Input";
import { toast } from "react-toastify";
import { getUserCheckins, saveCheckin } from "../api/events";

interface DialogConfirmProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  event: Event | null;
}
export default function DialogMakeCheckin({
  open,
  setOpen,
  event,
}: DialogConfirmProps) {
  const [selectedDayId, setSelectedDayId] = React.useState(event?.days[0].id);
  const [email, setEmail] = React.useState("");

  const handleClose = () => {
    setOpen(false);
  };

  React.useEffect(() => {
    console.log(event?.days);
    console.log(event?.id);
  }, [event]);

  const makeCheckin = () => {
    getUserByEmail(email).then((user) => {
      if (user.length === 0) {
        toast.error("Usuário não encontrado!");
        return;
      }

      getUserCheckins(user[0].uid, event?.id).then((checkins) => {
        const filteredCheckins = checkins.filter(
          (checkin) => checkin.day_id === selectedDayId
        );

        if (filteredCheckins.length > 0) {
          toast.error("Usuário já fez checkin nesse dia/aula!");
        } else {
          saveCheckin(user[0].uid, event?.id, selectedDayId).then(() => {
            toast.success("Checkin realizado com sucesso");
            setEmail("");
          });
        }
      });
    });
  };

  return (
    <React.Fragment>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>
          Fazer checkin no evento:
          <span style={{ marginLeft: 5, fontWeight: "bold" }}>
            {event?.title}
          </span>
        </DialogTitle>
        <DialogContent>
          <div>
            <Input
              title={"Email"}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <FormControl
              fullWidth
              variant="outlined"
              margin="normal"
              sx={{ marginTop: 4 }}
            >
              <InputLabel>Selecione o dia/aula</InputLabel>
              <Select
                value={selectedDayId}
                onChange={(e) => setSelectedDayId(e.target.value)}
                label="Selecione o dia/aula"
                style={{
                  borderRadius: "8px",
                  backgroundColor: "#FCFDFE",
                  justifyContent: "center",
                  marginTop: 12,
                }}
              >
                {event?.days.map((day: any) => (
                  <MenuItem key={day.id} value={day.id}>
                    {day.title}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>

          <DialogActions>
            <ButtonLoading label={"Cancelar"} onClick={handleClose} isDelete />
            <ButtonLoading label={"Salvar"} onClick={makeCheckin} />
          </DialogActions>
        </DialogContent>
      </Dialog>
    </React.Fragment>
  );
}
